import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useAppContext } from '../context/AppContext';
import summaryIcon from '../assets/zusammenfassung.png';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from 'date-fns/locale';
import './Danke.css';

function Danke() {
  const { state } = useAppContext();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
      <Box className="wrapper" role="main" aria-label="Zusammenfassung und beitragspflichtig beantragen">
        <Container className="main-content-scroll-container">
          <Box className="main-content-with-sidebar" id="jumpmark-maincontent" tabIndex={-1}>
            {/* --- PAGE CONTENT  --- */}
            <Box className="page-content">
              <Typography variant="h1" component="h1" style={{ marginBottom: '20px' }}>
                Vielen Dank für Dein Vertrauen!
              </Typography>

              <Box className="insured-summary-box">
                <Box className="insured-summary-box-content">
                  {/* Einleitungstext */}
                  <Typography variant="body1" component="p" className="text-18-normal">
                    Schön, dass du dich für die R+V Hardwareversicherung entschieden hast. Deine Daten sind sicher bei
                    uns eingegangen. Eine Unterschrift darüber hinaus ist nicht erforderlich. Wir kümmern uns um den
                    Rest.
                  </Typography>

                  {/* Dokumentenversand Text */}
                  <Typography variant="body1" component="p" className="text-18-normal">
                    Deinen Vertragsschein, Versicherungsbedingungen und Kundeninformation, Vertragsinformationen inkl.
                    Widerrufsbelehrung, Datenschutzerklärung und Beratungsprotokoll senden wir nach Prüfung direkt an
                    deine E-Mail-Adresse{' '}
                    <Box component="span" className="text-18-bold">
                      {state.applicationObject.applicant.contact[0].data || 'test@assona.com'}
                    </Box>
                    .
                  </Typography>

                  {/* Zusammenfassungs-Bild */}
                  <Box
                    className="insured-summary-box-image"
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mb: 6.25, // 50px
                    }}
                  >
                    <Box
                      component="img"
                      src={summaryIcon}
                      alt=""
                      role="presentation"
                      sx={{
                        height: 100,
                        maxWidth: '100%',
                        objectFit: 'contain',
                      }}
                      onError={e => {
                        // Fallback wenn Bild nicht gefunden wird
                        e.target.style.display = 'none';
                      }}
                    />
                  </Box>

                  {/* Schlusssatz */}
                  <Typography variant="body1" component="p" className="text-18-normal">
                    Im Versicherungsschein findest du deine Versicherungsnummer, die du im Schadensfall benötigst.
                    Bewahre daher deinen Versicherungsschein gut auf.
                  </Typography>
                </Box>
              </Box>
            </Box>{' '}
            {/* className="page-content" */}
            {/* --- ENDE PAGE CONTENT  --- */}
          </Box>{' '}
          {/* className="main-content-with-sidebar" */}
        </Container>{' '}
        {/* className="main-content-scroll-container" */}
      </Box>{' '}
      {/* className="wrapper" */}
    </LocalizationProvider>
  );
}

export default Danke;
